import { Box, Button, Circle, HStack, Image, Stack } from '@chakra-ui/react';
import React from 'react';
import { FaPlus, FaMinus } from 'react-icons/fa';
import { useCtx } from '../context/AppContext';

export default function SingleCartItem({ item }) {
  const { removeCartItem, increment, decrement } = useCtx();
  return (
    <HStack justifyContent={'space-between'} py="10" px="5">
      <HStack>
        <Image src={item.img} w="40%" />

        <Stack justifyContent={'space-around'} p="5">
          <Box as="span" fontSize={'sm'}>
            <b>Product: </b>
            {item.title}
          </Box>
          <Box as="span" fontSize={'sm'}>
            <b>ID: </b>
            {item.id}
          </Box>

          <Circle w="20px" h="20px" border="1px solid teal" bg={item.color} />
          <Box as="span" fontSize={'sm'}>
            <b>Size: </b>
            {item.size}
          </Box>
        </Stack>
      </HStack>

      <Stack alignItems={'center'} justifyContent="center" flex="1">
        <HStack mb="10" justifyContent={'center'} alignItems="center">
          <FaPlus
            style={{
              cursor: 'pointer',
            }}
            onClick={() => increment(item.id)}
          />
          <Box as="span" fontSize="20px" fontWeight={'200'}>
            {item.count}
          </Box>
          <FaMinus
            style={{
              cursor: 'pointer',
            }}
            onClick={() => decrement(item.id)}
          />
        </HStack>
        <Box as="span" fontSize="20px" fontWeight={'200'}>
          {item.price * item.count} USDT
        </Box>
        <Button
          colorScheme={'teal'}
          rounded="full"
          size="sm"
          onClick={() => removeCartItem(item.id)}
        >
          REMOVE
        </Button>
      </Stack>
    </HStack>
  );
}
